/* eslint-disable */
import './datadog'
import { setDatadogUser } from './datadog'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Api from './utils/api'
import Helpers from './utils/helpers'
import EventHub from './utils/EventHub'
import {
  vCan,
  vShowFeature,
  vShowProduct,
  vClickOutside,
  vClickOutsideStrict
} from './utils/directives'

import store from './store'

import { createPinia, PiniaVuePlugin } from 'pinia'
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

import VueCarousel from 'vue-carousel'
import VueCalendar from 'v-calendar'
import VueMeta from 'vue-meta'

import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import draggable from 'vuedraggable'

import dayjs from 'dayjs'
// date service: dayjs pré-configurado com plugins (isBetween, duration, localeData, utc, etc.)
// Usar '@shared/services/date' em código novo em vez de import moment ou dayjs diretamente
import '@shared/services/date'

import 'moment/locale/pt-br'
import 'dayjs/locale/pt-br'

import '@doctorassistant/daai-component'

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
// eslint-disable-next-line camelcase
import pt_BR from 'vee-validate/dist/locale/pt_BR'

import { cpf, cnpj } from 'cpf-cnpj-validator'

import BootstrapVue from 'bootstrap-vue'
import { REACT_LAYER_SELECTORS } from './utils/reactLayerSelectors'

import VueTheMask from 'vue-the-mask'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

// import vClickOutside from 'v-click-outside'

import VueSvgGauge from 'vue-svg-gauge'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import Notifications from 'vue-notification'

import ToggleButton from 'vue-js-toggle-button'

import money from 'v-money'

import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

// import pdf from 'vue-pdf'

import infiniteScroll from 'vue-infinite-scroll'

import VueCalendarHeatmap from 'vue-calendar-heatmap'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import VueSweetalert2 from 'vue-sweetalert2'

import Pusher from 'pusher-js'

import introJs from 'intro.js'
import 'intro.js/minified/introjs.min.css'

Pusher.logToConsole = import.meta.env.MODE == 'production'
const pusherKey = import.meta.env.VITE_PUSHER_KEY
var pusher = pusherKey
  ? new Pusher(pusherKey, {
      cluster: 'mt1'
    })
  : null

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, far)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue.use(signatureForm)
// Vue.use(signatureStartForm)
Vue.use(VueCarousel)
Vue.use(VueCalendar, {
  componentPrefix: 'vc'
})
// O enforceFocus do b-modal ignora as camadas React: elas moram fora do
// conteúdo do modal (root montado pelos wrappers + portais do Radix), e
// disputar o foco com o FocusScope do Radix trava a aba — ver
// REACT_LAYER_SELECTORS (card 86ak1qj0q).
Vue.use(BootstrapVue, {
  BModal: { ignoreEnforceFocusSelector: REACT_LAYER_SELECTORS }
})
Vue.use(VueTheMask)
Vue.use(DatePicker)
Vue.use(PerfectScrollbar)
// Vue.use(vClickOutside)
Vue.use(VueSvgGauge)
Vue.use(Loading, {
  canCancel: true,
  enforceFocus: false
})
Vue.use(Notifications)
Vue.use(ToggleButton)
Vue.use(money, { decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2 })
Vue.use(Viewer)
Vue.use(infiniteScroll)
Vue.use(VueMeta)
Vue.use('Encryption')
Vue.use(Toast, {
  maxToasts: 5,
  newestOnTop: true,
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter(t => t.content === toast.content).length !== 0) {
      return false
    }
    return toast
  }
})
Vue.use(moment)
Vue.use(VueSweetalert2)
import 'sweetalert2/dist/sweetalert2.min.css'

// Vue.use(PDFLib)

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

Vue.component('multiselect', Multiselect)

Vue.component('VueCropper', VueCropper)

// Vue.component('pdf', pdf)
Vue.component('draggable', draggable)

Vue.use(VueCalendarHeatmap)
// A chamada da biblioteca foi comentada porquê não está sendo utilizada no projeto.
// Vue.use(VueApexCharts);
// Vue.component("apexchart", VueApexCharts);
import draggableButton from 'vue-draggable-button'
Vue.use(draggableButton)

// Validation Rules
for (const rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: pt_BR.messages[rule]
  })
}

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'As senhas digitadas não são iguais'
})

extend('diff', {
  params: ['target'],
  validate(value, { target }) {
    return value !== target
  },
  message: 'A nova senha deve ser diferente da senha atual'
})

extend('cpf', {
  validate(value, _args) {
    return cpf.isValid(value)
  },
  message: 'O CPF informado é inválido'
})

extend('cnpj', {
  validate(value, _args) {
    return cnpj.isValid(value)
  },
  message: 'O CNPJ informado é inválido'
})

extend('min_value', {
  params: ['min'],
  validate(value, { min }) {
    if (!value && value !== 0) return false
    const numValue = parseFloat(value)
    return !isNaN(numValue) && numValue >= parseFloat(min)
  },
  message: (field, params) => {
    return `O valor deve ser igual ou maior que ${params.min}`
  }
})

extend('date_format', {
  validate(value, args) {
    const date = moment(value, args[0])

    return date.isValid()
  },
  message: 'A data informada é inválida'
})

extend('password_strength', {
  message:
    'A senha deve conter pelo menos: 1 letra maiúscula, 1 letra minúscula, 1 número e um caractere especial (Ex ! @ # & $ etc)',
  validate: value => {
    // eslint-disable-next-line no-useless-escape
    var strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
    )
    return strongRegex.test(value)
  }
})

Vue.config.productionTip = false

// moment-range removed (was imported but never used)
momentDurationFormatSetup(moment)

// Definir locale globalmente com configuração explicita
moment.locale('pt-br', {
  months:
    'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split(
      '_'
    ),
  monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
  weekdays:
    'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
      '_'
    ),
  weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
  weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
  },
  calendar: {
    sameDay: '[Hoje às] LT',
    nextDay: '[Amanhã às] LT',
    nextWeek: 'dddd [às] LT',
    lastDay: '[Ontem às] LT',
    lastWeek: function () {
      return this.day() === 0 || this.day() === 6
        ? '[Último] dddd [às] LT'
        : '[Última] dddd [às] LT'
    },
    sameElse: 'L'
  },
  relativeTime: {
    future: 'em %s',
    past: 'há %s',
    s: 'poucos segundos',
    ss: '%d segundos',
    m: 'um minuto',
    mm: '%d minutos',
    h: 'uma hora',
    hh: '%d horas',
    d: 'um dia',
    dd: '%d dias',
    M: 'um mês',
    MM: '%d meses',
    y: 'um ano',
    yy: '%d anos'
  },
  dayOfMonthOrdinalParse: /\d{1,2}º/,
  ordinal: '%dº'
})

moment.locale('pt-br')
Vue.prototype.moment = moment
Vue.prototype.moment.locale('pt-br')

dayjs.locale('pt-br')

Vue.config.warnHandler = () => {}
Vue.config.silent = true

Vue.prototype.dayjs = dayjs

Vue.prototype.api = Api
Vue.prototype.helpers = Helpers
Vue.prototype.eventHub = EventHub
Vue.prototype.pusher = pusher
// Mesma instância exposta para as ilhas React (react-apps/shared/pusher).
// O React não tem `Vue.prototype`, e criar um `new Pusher(...)` do lado dele
// abriria um SEGUNDO socket para o mesmo usuário — dobrando conexão e
// entrega de mensagens. Uma referência é mais barata que uma conexão.
window.__pusher = pusher
Vue.prototype.introJs = introJs
Vue.prototype.router = router

Vue.directive('can', vCan)
Vue.directive('show-feature', vShowFeature)
Vue.directive('show-product', vShowProduct)
Vue.directive('click-outside', vClickOutside)
Vue.directive('click-outside-strict', vClickOutsideStrict)

// Diretiva v-safe-html — substitui v-html com sanitização XSS
import { safeHtml } from '@shared/directives/safeHtml'
Vue.directive('safe-html', safeHtml)

import { registerModules } from './register-modules'
import unityHandlerModule from './modules/unityHandler'
import designSystemModule from './modules/designSystem'
import financialModule from './modules/financial'
import featureRequests from './modules/featureRequests'
import bvPendingRequestsModule from './modules/bvPendingRequests'
import newFeaturesModule from './modules/newFeatures'
import nfeModule from './modules/nfe'
import matMedModule from './modules/tiss/matMed'
import manageGuidesModule from './modules/tiss/manageGuides'
import matMedModuleSus from './modules/sus/matMed'
import manageGuidesModuleSus from './modules/sus/manageGuides'
import schedule from './modules/schedule'
import scheduleConfig from './modules/scheduleConfig'
import onlendinglModule from './modules/onlending'
import patientsModule from './modules/patients'
import scheduleSidebar from './modules/scheduleSidebar'
import tablesModule from './modules/tables'
import itemsModule from './modules/items'
import itemHealthPlanProps from './modules/itemHealthPlanProps'
import itemOtherExpenseProps from './modules/itemOtherExpenseProps'
import matMed from './modules/matMed'
import examsModule from './modules/exams'
import attendance from './modules/attendance'
import agendaOftalmo from './modules/agendaOftalmo'
import emergencyRoomModule from './modules/emergencyRoom'
import clinicModule from './modules/clinic'
import loginModule from './modules/login'
import healthPlanModule from './modules/healthPlan'
import surgeryCenterModule from './modules/surgeryCenter'
import {
  getCurrentUser,
  setClarityIdentifier
} from './utils/localStorageManager'

setDatadogUser(getCurrentUser())

registerModules({
  unityHandler: unityHandlerModule,
  designSystem: designSystemModule,
  bvPendingRequests: bvPendingRequestsModule,
  featureRequests: featureRequests,
  financial: financialModule,
  manageGuides: manageGuidesModule,
  manageGuidesSus: manageGuidesModuleSus,
  matMed: matMedModule,
  matMedSus: matMedModuleSus,
  newFeatures: newFeaturesModule,
  nfe: nfeModule,
  onlending: onlendinglModule,
  schedule: schedule,
  scheduleConfig,
  scheduleSidebar,
  items: itemsModule,
  tables: tablesModule,
  itemHealthPlanProps,
  itemOtherExpenseProps,
  matMed,
  patients: patientsModule,
  scheduleSidebar,
  exams: examsModule,
  attendanceStore: attendance,
  agendaOftalmo: agendaOftalmo,
  emergencyRoom: emergencyRoomModule,
  clinic: clinicModule,
  login: loginModule,
  healthPlan: healthPlanModule,
  surgeryCenter: surgeryCenterModule
})

new Vue({
  created() {
    document.documentElement.setAttribute('lang', 'pt-BR')

    const setClarityId = () => {
      try {
        const user = getCurrentUser()
        if (user && user.email) {
          setClarityIdentifier(user.email)
        }
      } catch (e) {
        console.error('Error setting Clarity identifier:', e)
      }
    }

    // Delay after the app is loaded to ensure Clarity is loaded
    setTimeout(setClarityId, 1000)
  },
  pinia,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('storage', event => {
  if (event.key === 'singItemAutentic') {
    const itemAutentic = JSON.parse(event.newValue)
    store.dispatch('attendanceStore/setCertificate', itemAutentic)
  }
})
